<template>
  <VSection large label="transactions.persistent_confirmation_persistentConfirmation">
    <VSection label="transactions.persistent_confirmation_persistentConfirmationDetails" level="5">
      <VDescriptionListDivided>
        <VEntry :data="transactionDetails" field="confirmationId">
          <template #override="{ value }">
            <dt>
              <span v-html="$t('transactions.persistent_confirmation_confirmationId')"></span>
              <VButton
                v-if="hasAccessPersistentConfirmations"
                class="btn-default btn-small pull-right offset-bottom-1"
                label="transactions.persistent_confirmation_confirmationId_button"
                :to="{ name: PERSISTENT_CONFIRMATIONS_DETAILS, params: { id: value, tab: $route.params.tab } }"
              />
            </dt>
            <dd>
              {{ value }}
            </dd>
          </template>
        </VEntry>
        <VEntry
          :data="transactionDetails"
          field="confirmationDetails.createdByTransactionId"
          name="transactions.persistent_confirmation_createdByTransactionId"
        />
        <VEntryDate :data="transactionDetails" field="confirmationDetails.creationTime" name="transactions.persistent_confirmation_creationTime" />
        <VEntry
          :data="transactionDetails"
          field="confirmationDetails.reusedByTransactionId"
          name="transactions.persistent_confirmation_reusedByTransactionId"
        />
        <VEntryDate :data="transactionDetails" field="confirmationDetails.reusedTime" name="transactions.persistent_confirmation_reusedTime" />
        <VEntry :data="transactionDetails" field="confirmationDetails.serviceDescription" name="transactions.persistent_confirmation_serviceDescription" />
        <VEntry
          :data="transactionDetails"
          field="confirmationDetails.maxApplicableDiscount"
          name="transactions.persistent_confirmation_maxApplicableDiscount"
        />
        <VEntry :data="transactionDetails" field="confirmationDetails.chargingCycle" name="transactions.persistent_confirmation_chargingCycle" />
        <VEntry :data="transactionDetails" field="confirmationDetails.contentCategory" name="transactions.persistent_confirmation_contentCategory" />
        <VEntry :data="transactionDetails" field="confirmationDetails.contentType" name="transactions.persistent_confirmation_contentType" />
        <VEntryDate
          :data="transactionDetails"
          field="confirmationDetails.nextIdealChargingDate"
          name="transactions.persistent_confirmation_nextIdealChargingDate"
        />
        <VEntryDate :data="transactionDetails" field="confirmationDetails.chargingSlotBegin" name="transactions.persistent_confirmation_chargingSlotBegin" />
        <VEntryDate :data="transactionDetails" field="confirmationDetails.chargingSlotEnd" name="transactions.persistent_confirmation_chargingSlotEnd" />
        <VEntry :data="transactionDetails" field="confirmationDetails.numberOfUpdates" name="transactions.persistent_confirmation_numberOfUpdates" />
        <VEntry :data="transactionDetails" field="confirmationDetails.confirmationTypeId" name="transactions.persistent_confirmation_confirmationTypeId" />
        <VEntry :data="transactionDetails" field="confirmationDetails.confirmationTypeText" name="transactions.persistent_confirmation_confirmationTypeText" />
        <VEntry
          :data="transactionDetails"
          field="confirmationDetails.maxMissedChargingCycles"
          name="transactions.persistent_confirmation_maxMissedChargingCycles"
        />
        <VEntry :data="transactionDetails" field="confirmationDetails.confirmationClassId" name="transactions.persistent_confirmation_confirmationClassId" />
        <VEntryDate
          :data="transactionDetails"
          field="confirmationDetails.importedCreationDate"
          name="transactions.persistent_confirmation_importedCreationDate"
        />
        <VEntry
          :data="transactionDetails"
          field="confirmationDetails.missedChargingCyclesCount"
          name="transactions.persistent_confirmation_missedChargingCyclesCount"
        />
        <VEntry :data="transactionDetails" field="confirmationDetails.vasCode" name="transactions.persistent_confirmation_vasCode" />
        <VEntry :data="transactionDetails" field="confirmationDetails.numberOfUnits" name="transactions.persistent_confirmation_numberOfUnits" />
      </VDescriptionListDivided>
    </VSection>
  </VSection>
</template>

<script>
import { mapGetters } from 'vuex';
import VSection from '@/components/Section';
import VDescriptionListDivided from '@/components/DescriptionList/Divided';
import VEntry from '@/components/DescriptionList/Entry';
import VEntryDate from '@/components/DescriptionList/EntryDate';
import VButton from '@/components/Button';
import { PERSISTENT_CONFIRMATIONS_DETAILS } from '@/router/route-types';

export default {
  name: 'PaymentTransactionsDetailsConfirmations',

  components: {
    VSection,
    VDescriptionListDivided,
    VEntry,
    VEntryDate,
    VButton,
  },

  props: {
    transactionDetails: {
      type: Object,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      PERSISTENT_CONFIRMATIONS_DETAILS,
    };
  },

  computed: {
    ...mapGetters('system', ['hasAccessPersistentConfirmations']),
  },
};
</script>
